
import Vuex from 'vuex'


export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token')?localStorage.getItem('token') : '',
    userName : localStorage.getItem('userName') ?localStorage.getItem('userName') : '',
    distributorId : localStorage.getItem('distributorId') ?localStorage.getItem('distributorId') : '',
    mobile : localStorage.getItem('mobile') ?localStorage.getItem('mobile') : '',
    searchType : null
  },
  mutations: {
    setToken (state, token) {
      state.token = token
      localStorage.setItem('token',token);
    },
    setUserName (state, name) {
      state.userName = name
      localStorage.setItem('userName',name);
    },
    setDistributorId (state, distributorId) {
      state.distributorId = distributorId
      localStorage.setItem('distributorId',distributorId);
    },
    setMobile (state, mobile) {
      state.mobile = mobile
      localStorage.setItem('mobile',mobile);
    },
    setSearchType (state, searchType) {
      state.searchType = searchType;
    }
  },
  actions: {

  },
  modules: {

  }
})
